/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsGetApiKey } from "../../funcs/budgetsGetApiKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiKeyBudgetsRequest$inboundSchema,
};

export const tool$budgetsGetApiKey: ToolDefinition<typeof args> = {
  name: "budgets-get-api-key",
  description: `List apikey budgets

Returns the apikey's budgets (self-budget and/or ceiling) with each one's live spend gauge. Callable by cluster admins, or org admins for API keys in their own organization.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsGetApiKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
